import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangeofserviceComponent } from './changeofservice.component';

const routes: Routes = [
    {
        path: '',
        component: ChangeofserviceComponent,
        data: {
            title: 'Change of Service Component'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ChangeofserviceRoutingModule { }
